import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

const useResizeObserver = (
	cb: (entry: ResizeObserverEntry) => void,
): {
	setRef: Dispatch<SetStateAction<Element | null>>;
} => {
	const [ref, setRef] = useState<Element | null>(null);

	useEffect(() => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (!ref || !window.ResizeObserver) return undefined;

		const observer = new ResizeObserver((entries) => {
			cb(entries[0]);
		});

		observer.observe(ref);

		return () => {
			observer.disconnect();
		};
	}, [ref, cb]);

	return { setRef };
};

export default useResizeObserver;
